import React, { useMemo } from "react";
import { Calculator } from "lucide-react";

interface LaneCalculationProps {
  cards: any[];
}

/** Calculation summary row displayed at the bottom of each lane */
const LaneCalculation: React.FC<LaneCalculationProps> = ({ cards }) => {
  const stats = useMemo(() => {
    let totalDealValue = 0;
    let totalActivities = 0;
    let totalEmails = 0;
    let hasValues = false;

    cards.forEach((card: any) => {
      const task = card.task;
      if (!task) return;

      const dealValue = parseFloat(
        task.getIn ? task.getIn(["data", "estimatedRevenue", "value"]) || "0" : "0"
      );
      const activities = parseInt(
        task.getIn ? task.getIn(["data", "totalActivities", "value"]) || "0" : "0",
        10
      );
      const emails = parseInt(
        task.getIn ? task.getIn(["data", "totalEmails", "value"]) || "0" : "0",
        10
      );

      if (dealValue > 0) {
        totalDealValue += dealValue;
        hasValues = true;
      }
      if (activities > 0) {
        totalActivities += activities;
        hasValues = true;
      }
      if (emails > 0) {
        totalEmails += emails;
        hasValues = true;
      }
    });

    return { totalDealValue, totalActivities, totalEmails, hasValues };
  }, [cards]);

  if (!stats.hasValues || cards.length === 0) return null;

  return (
    <div className="mx-1 mt-1 mb-2 px-3 py-2 bg-gray-50 rounded-md border border-gray-100">
      <div className="flex items-center gap-1.5 mb-1">
        <Calculator className="w-3 h-3 text-gray-400" />
        <span className="text-[10px] font-medium text-gray-400 uppercase tracking-wide">
          Summary
        </span>
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-0.5 text-xs text-gray-600">
        <div>
          <span className="text-gray-400">Count:</span>{" "}
          <span className="font-medium">{cards.length}</span>
        </div>
        {stats.totalDealValue > 0 && (
          <div>
            <span className="text-gray-400">Value:</span>{" "}
            <span className="font-medium text-green-600">
              ${stats.totalDealValue.toLocaleString()}
            </span>
          </div>
        )}
        {stats.totalActivities > 0 && (
          <div>
            <span className="text-gray-400">Activities:</span>{" "}
            <span className="font-medium">{stats.totalActivities}</span>
          </div>
        )}
        {stats.totalEmails > 0 && (
          <div>
            <span className="text-gray-400">Emails:</span>{" "}
            <span className="font-medium">{stats.totalEmails}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default LaneCalculation;
